import { Box, Typography } from "@mui/material";
import { incidentTypes } from "../../types";
import { styleMapper } from "../styles";

function Legend() {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
        alignItems: "center",
        justifyContent: "space-around",
        paddingTop: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: "999px",
            backgroundColor: styleMapper.outline.colour,
          }}
        />
        <Typography sx={{ fontSize: "12px" }}>Project boundaries</Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: "999px",
            backgroundColor: styleMapper.buffer.colour,
            opacity: styleMapper.buffer.opacity,
          }}
        />
        <Typography sx={{ fontSize: "12px" }}>Buffer</Typography>
      </Box>

      {incidentTypes.map((incidentType) => (
        <Box
          key={incidentType}
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <Box
            sx={{
              width: 14,
              height: 14,
              borderRadius: "999px",
              backgroundColor: styleMapper[incidentType].colour,
            }}
          />
          <Typography sx={{ fontSize: "12px" }}>{incidentType}</Typography>
        </Box>
      ))}
    </Box>
  );
}

export default Legend;
